var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWttsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2201 6.15071C25.2252 3.15395 21.2422 1.50182 16.9991 1.5C8.25263 1.5 1.13646 8.61253 1.13464 17.3553C1.13101 20.1374 1.86064 22.8722 3.25075 25.283L1 33.5L9.40985 31.2947C11.737 32.5611 14.3426 33.2253 16.9918 33.2253H16.9991C25.7419 33.2253 32.8581 26.1109 32.8617 17.3681C32.8635 13.1322 31.215 9.14929 28.2201 6.15071Z",
    stroke: "#433AC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9244 20.3392L19.6631 19.6059C20.3418 18.9327 21.4153 18.8472 22.1977 19.3967C22.9546 19.928 23.6388 20.4047 24.2756 20.8487C25.2872 21.551 25.4092 22.9921 24.5376 23.8618L23.8844 24.515",
    stroke: "#433AC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91774 10.5483L10.5709 9.89514C11.4407 9.0254 12.8817 9.14731 13.5841 10.1571C14.0262 10.794 14.5029 11.4781 15.0361 12.235C15.5856 13.0174 15.5019 14.091 14.8268 14.7696L14.0936 15.5084",
    stroke: "#433AC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8843 24.5146C21.1896 27.1965 16.6608 24.9185 13.0854 21.3413",
    stroke: "#433AC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0892 21.3467C9.51378 17.7695 7.23574 13.2426 9.91772 10.5479",
    stroke: "#433AC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0939 15.5083C14.6743 16.4235 15.4185 17.3296 16.2591 18.1703L16.2628 18.1739C17.1034 19.0145 18.0095 19.7587 18.9247 20.3391",
    stroke: "#433AC8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWttsBlue);
export default __webpack_public_path__ + "static/media/wtts-blue.b0682de7718b57a97b1c24efdf01f786.svg";
export { ForwardRef as ReactComponent };